import React from 'react';
import { FileText } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const ContractsPage = () => {
  const serviceData = {
    icon: FileText,
    nameAr: 'دائرة العقود والشركات',
    nameEn: 'Contracts and Companies Department',
    taglineAr: 'صياغة ومراجعة العقود وتأسيس الكيانات القانونية',
    taglineEn: 'Drafting and reviewing contracts and establishing legal entities',
    
    descriptionAr: [
      'دائرة العقود والشركات في وازن متخصصة في تقديم خدمات قانونية متكاملة تشمل صياغة ومراجعة جميع أنواع العقود، وتأسيس الشركات والكيانات القانونية المختلفة. نحرص على حماية مصالح عملائنا من خلال عقود محكمة ومتوافقة مع الأنظمة السعودية.',
      'يتمتع فريقنا بخبرة واسعة في التعامل مع الصفقات التجارية المعقدة، الاستحواذات، والاندماجات، ونقدم دعماً قانونياً شاملاً للشركات في جميع مراحل نموها.'
    ],
    descriptionEn: [
      'Wazin\'s Contracts and Companies Department specializes in providing comprehensive legal services including drafting and reviewing all types of contracts, and establishing various companies and legal entities. We ensure the protection of our clients\' interests through solid contracts compliant with Saudi regulations.',
      'Our team has extensive experience in handling complex commercial transactions, acquisitions, and mergers, and we provide comprehensive legal support to companies at all stages of their growth.'
    ],

    services: [
      {
        nameAr: 'صياغة العقود التجارية بمختلف أنواعها (بيع، شراء، توريد، تقديم خدمات، شراكات)',
        nameEn: 'Drafting commercial contracts of all types (sale, purchase, supply, services, partnerships)',
        descAr: 'إعداد وصياغة جميع أنواع العقود التجارية بما يحقق التوازن بين حقوق والتزامات الأطراف',
        descEn: 'Preparing and drafting all types of commercial contracts balancing rights and obligations of parties'
      },
      {
        nameAr: 'مراجعة العقود والتحقق من سلامتها النظامية ومصالح العميل',
        nameEn: 'Reviewing contracts and verifying legal soundness and client interests',
        descAr: 'فحص دقيق للعقود للتأكد من توافقها مع الأنظمة وحماية مصالح العميل',
        descEn: 'Precise examination of contracts to ensure compliance with regulations and protection of client interests'
      },
      {
        nameAr: 'تعديل العقود القائمة بما يتوافق مع الأنظمة والتغييرات التجارية',
        nameEn: 'Amending existing contracts in accordance with regulations and commercial changes',
        descAr: 'إجراء التعديلات اللازمة على العقود القائمة لتتوافق مع التطورات النظامية والتجارية',
        descEn: 'Making necessary amendments to existing contracts to comply with regulatory and commercial developments'
      },
      {
        nameAr: 'صياغة مذكرات التفاهم (MoU) والاتفاقات المبدئية',
        nameEn: 'Drafting Memorandums of Understanding (MoU) and preliminary agreements',
        descAr: 'إعداد مذكرات التفاهم والاتفاقيات التمهيدية التي تسبق التعاقدات النهائية',
        descEn: 'Preparing memorandums of understanding and preliminary agreements preceding final contracts'
      },
      {
        nameAr: 'صياغة ومراجعة السياسات واللوائح الداخلية للشركات',
        nameEn: 'Drafting and reviewing internal policies and regulations for companies',
        descAr: 'إعداد السياسات الداخلية واللوائح التنظيمية للشركات بما يتوافق مع الأنظمة',
        descEn: 'Preparing internal policies and organizational regulations for companies in compliance with regulations'
      },
      {
        nameAr: 'تأسيس الشركات بجميع أنواعها وفقاً للأنظمة السعودية',
        nameEn: 'Establishing companies of all types according to Saudi regulations',
        descAr: 'إنهاء جميع إجراءات تأسيس الشركات المختلفة وفق نظام الشركات السعودي',
        descEn: 'Completing all procedures for establishing various companies according to Saudi Companies Law'
      },
      {
        nameAr: 'تعديل عقود تأسيس الشركات وقرارات الشركاء',
        nameEn: 'Amending company formation contracts and partners decisions',
        descAr: 'إجراء التعديلات اللازمة على عقود التأسيس وقرارات الشركاء والمساهمين',
        descEn: 'Making necessary amendments to formation contracts and partners and shareholders decisions'
      },
      {
        nameAr: 'إنهاء إجراءات تسجيل الشركات أمام الجهات المختصة',
        nameEn: 'Completing company registration procedures with competent authorities',
        descAr: 'متابعة وإنهاء جميع إجراءات تسجيل الشركات لدى وزارة التجارة والجهات ذات العلاقة',
        descEn: 'Following up and completing all company registration procedures with Ministry of Commerce and related entities'
      },
      {
        nameAr: 'إعداد محاضر الجمعيات والاجتماعات للشركاء أو المساهمين',
        nameEn: 'Preparing assembly and meeting minutes for partners or shareholders',
        descAr: 'توثيق وإعداد محاضر اجتماعات الجمعيات العمومية وقرارات الشركاء',
        descEn: 'Documenting and preparing minutes of general assembly meetings and partners decisions'
      },
      {
        nameAr: 'إعداد وتنفيذ برامج الحوكمة الداخلية للشركات',
        nameEn: 'Preparing and implementing internal governance programs for companies',
        descAr: 'تصميم وتطبيق أنظمة الحوكمة الداخلية للشركات وفق أفضل الممارسات',
        descEn: 'Designing and implementing internal governance systems for companies according to best practices'
      },
      {
        nameAr: 'إعداد اتفاقيات الشركاء (Shareholders Agreements)',
        nameEn: 'Preparing Shareholders Agreements',
        descAr: 'صياغة اتفاقيات الشركاء التي تنظم العلاقة بين المساهمين وآلية اتخاذ القرارات',
        descEn: 'Drafting shareholders agreements regulating relationships between shareholders and decision-making mechanisms'
      },
      {
        nameAr: 'صياغة عقود العمل والسياسات المرتبطة بالعلاقة العمالية',
        nameEn: 'Drafting employment contracts and labor-related policies',
        descAr: 'إعداد عقود العمل واللوائح الداخلية للموظفين وفق نظام العمل السعودي',
        descEn: 'Preparing employment contracts and internal regulations for employees according to Saudi Labor Law'
      },
      {
        nameAr: 'إعداد وصياغة عقود الامتياز التجاري الداخلي بالتكامل مع دائرة الامتياز',
        nameEn: 'Preparing domestic franchise contracts in integration with Franchise Department',
        descAr: 'صياغة عقود الامتياز التجاري الداخلية بالتنسيق مع دائرة الامتياز التجاري',
        descEn: 'Drafting domestic franchise contracts in coordination with Franchise Department'
      }
    ],

    specializations: [
      { ar: 'عقود الشركات التجارية', en: 'Commercial Company Contracts' },
      { ar: 'عقود التوريد والتوزيع', en: 'Supply and Distribution Contracts' },
      { ar: 'عقود الخدمات', en: 'Service Contracts' },
      { ar: 'عقود الإنشاءات', en: 'Construction Contracts' },
      { ar: 'عقود التكنولوجيا والبرمجيات', en: 'Technology and Software Contracts' },
      { ar: 'اتفاقيات السرية (NDA)', en: 'Confidentiality Agreements (NDA)' },
      { ar: 'عقود الاستشارات', en: 'Consulting Contracts' },
      { ar: 'عقود الشراكة الاستراتيجية', en: 'Strategic Partnership Contracts' },
      { ar: 'تأسيس الشركات الأجنبية', en: 'Foreign Company Establishment' },
      { ar: 'تسجيل الكيانات التجارية', en: 'Commercial Entity Registration' }
    ],

    faqs: [
      {
        questionAr: 'كم يستغرق تأسيس شركة في السعودية؟',
        questionEn: 'How long does it take to establish a company in Saudi Arabia?',
        answerAr: 'يستغرق تأسيس الشركة عادةً من أسبوعين إلى شهر، حسب نوع الشركة والوثائق المطلوبة. نقوم بتسريع الإجراءات من خلال علاقاتنا مع الجهات الحكومية.',
        answerEn: 'Company establishment usually takes two weeks to a month, depending on the type of company and required documents. We expedite procedures through our relationships with government entities.'
      },
      {
        questionAr: 'ما أنواع الشركات التي يمكن تأسيسها؟',
        questionEn: 'What types of companies can be established?',
        answerAr: 'نساعد في تأسيس جميع أنواع الشركات: شركة ذات مسؤولية محدودة، شركة مساهمة، شركة تضامن، شركة توصية، مؤسسة فردية، وفروع الشركات الأجنبية.',
        answerEn: 'We help establish all types of companies: limited liability company, joint-stock company, general partnership, limited partnership, sole proprietorship, and branches of foreign companies.'
      },
      {
        questionAr: 'هل توفرون خدمة مراجعة العقود الموجودة؟',
        questionEn: 'Do you provide existing contract review services?',
        answerAr: 'نعم، نقدم خدمة مراجعة شاملة للعقود الموجودة لدى عملائنا، مع تحديد نقاط الضعف والمخاطر القانونية، وتقديم التوصيات بالتعديلات اللازمة.',
        answerEn: 'Yes, we provide comprehensive review of existing contracts for our clients, identifying weaknesses and legal risks, and providing recommendations for necessary amendments.'
      },
      {
        questionAr: 'ما تكلفة صياغة عقد؟',
        questionEn: 'What is the cost of drafting a contract?',
        answerAr: 'تختلف التكلفة حسب نوع العقد ومدى تعقيده. نقدم عروض أسعار مخصصة بعد تقييم احتياجاتكم. كما نوفر باقات اشتراكية للشركات تشمل خدمات صياغة ومراجعة العقود.',
        answerEn: 'The cost varies depending on the type of contract and its complexity. We provide customized quotes after assessing your needs. We also offer subscription packages for companies including contract drafting and review services.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default ContractsPage;